import { get } from 'lodash';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BigNumber from '../../../../frontend/components/components/utils/numbers/BigNumber';
import Percent from '../../../../frontend/components/components/utils/numbers/Percent';
import { isString } from 'lodash-es';

const Profile = ({
  data,
  followers = true,
  engagementRate = false,
  videoEngRate = false,
  staticEngRate = false,
  suscriberRatio = false,
  numberVideos = false,
  authenticFollowers = false,
  subscribers = false,
  viewToSubscriberRatio = false,
  averagePlayToFollowerRatio = false
}) => {
  const { t } = useTranslation();
  if (!data) return;

  const elementsActive = followers + subscribers + engagementRate + videoEngRate + staticEngRate + suscriberRatio + viewToSubscriberRatio + numberVideos + authenticFollowers;

  const getMetricPercentage = (metric) => {
    const metricPercentage = get(data, `stats.${metric}`);

    return isString(metricPercentage) ?
      metricPercentage :
      <Percent number={metricPercentage || 0.0} />
  };

  return (<React.Fragment>
    <h4 className='mb-4'>
      {t('common.pages.analytics.profile')}
    </h4>
    <Row className='mb-6'>
      {
        followers &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3><BigNumber number={get(data, 'stats.followers') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.followers')}
          </div>
        </Col>
      }
      {
        subscribers &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3><BigNumber number={get(data, 'stats.subscribers') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.subscribers')}
          </div>
        </Col>
      }
      {
        engagementRate &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3>{getMetricPercentage('eng_rate')}</h3>
          <div className="mb-3">
            {t('common.pages.analytics.engagement')}
          </div>
        </Col>
      }
      {
        videoEngRate &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3>{getMetricPercentage('video_eng_rate')}</h3>
          <div className="mb-3">
            {t('common.pages.analytics.video_eng_rate')}
          </div>
        </Col>
      }
      {
        staticEngRate &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3>{getMetricPercentage('static_eng_rate')}</h3>
          <div className="mb-3">
            {t('common.pages.analytics.static_eng_rate')}
          </div>
        </Col>
      }
      {
        suscriberRatio &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3><Percent number={get(data, 'stats.eng_rate') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.subscriber_ratio')}
          </div>
        </Col>
      }
      {
        viewToSubscriberRatio &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3><Percent number={get(data, 'stats.view_to_subscriber_ratio') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.view_to_subscriber_ratio')}
          </div>
        </Col>
      }
      {
        numberVideos &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3><Percent number={get(data, 'stats.eng_rate') || 0} /></h3>
          <div className="mb-3">
            {t('common.pages.analytics.number_of_videos')}
          </div>
        </Col>
      }
 
      { averagePlayToFollowerRatio &&
          get(data, 'stats.avg_play_to_follower_ratio') &&
          <Col xs={12} sm={4}>
            <h3><Percent number={get(data, 'stats.avg_play_to_follower_ratio') || 0} /></h3>
            <div className="mb-3">
              {t('common.pages.analytics.average_play_to_follower_ratio')}
            </div>
          </Col>
      }

      {
        authenticFollowers &&
        <Col xs={12} sm={elementsActive % 2 === 0 ? 6 : 4}>
          <h3>{getMetricPercentage('authentic_followers')}</h3>
          <div className="mb-3">
            {t('common.pages.analytics.authentic_followers')}
          </div>
        </Col>
      }
    </Row>
  </React.Fragment >);
};

export default React.memo(Profile);
